import axios from 'axios';
import store from '../store'
import router from "../router";

class AuthRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    getUsernameFromEmail(email){
        return axios.get(`${this.basePath}/ext/users/username/by-email/${email}`);
    }

    editProfile(profileData) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/users/edit`, profileData,{headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    existingUsernameOrEmail(username, email){
        return axios.get(`${this.basePath}/ext/users/exists?username=${username}&email=${email}`);
    }

    registerUser(userData) {
        return axios.post(`${this.basePath}/register-user`, userData);
    }

    confirmedEmail(key) {
        return axios.get(`${this.basePath}/activate?key=${key}`);
    }

    resetPassword(email) {
        return axios.post(`${this.basePath}/account/reset-password/init`, email);
    }

    finishResetPassword(password, key) {
        return axios.post(`${this.basePath}/account/reset-password/finish`, {newPassword: password, key: key});
    }

    login(username, password) {
        let body = { username: username, password: password };
        return axios.post(`${this.basePath}/authenticate/admin`, body);
    }

    logout(username) {
        let headers = {'Authorization': store.state.token};
        return axios.get(`${this.basePath}/authenticate/${username}`, {headers: headers});
    }

    getUser() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/account`, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
        //return axios.get(`${this.basePath}/account`, {headers: headers});
    }

    getUserDetails(userId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/user-details/user/${userId}`, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    isPro(userId){
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/user-details/user/pro/${userId}`, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }
}

export default new AuthRepository();
